"use client";

import {
  Breadcrumb,
  Button,
  Col,
  Row,
  Divider,
  Modal,
  Image as ImageAntd,
} from "antd";
import Link from "next/link";
import ImageCommon from "@/src/component/image/image";
import "./doctordetail.scss";
import StarRatings from "react-star-ratings";
import { Link as LinkScroll, Element, scroller } from "react-scroll";
import ChatBox from "@/src/component/detail/chatbox";
import WorkPlace from "../../../component/doctor/work-place";
import _ from "lodash";
import Post from "@/src/component/doctor/post";
import Review from "@/src/component/detail/review";
import { EditOutlined, EyeOutlined, MessageOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import iconClose from "@/public/icon/icon-close.png";
import Image from "next/image";
import { PREFIX_IMAGE_URL } from "@/src/const/const";
import defaultImage from "@/public/image/default-thumbnail.jpg";
import iconArrow from "@/public/icon/arrow-float-button.svg";
import chatAlert from "@/public/icon/chat-alert.svg";
import DiaryDoctor from "@/src/component/doctor/diary-doctor";
import { FALLBACK } from "@/src/const/const";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperButtonNext from "@/src/component/detail/swiper-button.js";
import { Pagination, Autoplay, Scrollbar } from "swiper/modules";
import { getDiaries } from "../service";
const dataMenuSection = [
  { id: "gioi-thieu", name: "Giới thiệu" },
  { id: "kinh-nghiem", name: "Kinh nghiệm" },
  { id: "bang-cap", name: "Bằng chấp, chứng chỉ" },
  { id: "cong-tac", name: "Nơi công tác" },
  { id: "showcase", name: "Showcase" },
  { id: "hoat-dong", name: "Hoạt động" },
  { id: "danh-gia", name: "Đánh giá" },
];

export default function DetailDoctorClient(props) {
  const { doctor, clinicSlug } = props;
  const clinicName = doctor?.doctor_clinic?.find(
    (clinicObj) => clinicObj.clinic.slug === clinicSlug
  )?.clinic?.name;
  const [dataShowcase, setDataShowcase] = useState();
  const [openModalChat, setOpenModalChat] = useState(false);
  const [openModalRating, setOpenModalRating] = useState(false);
  const [appendChatAlert, setAppendChatAlert] = useState(true);
  const debounceScroll = _.debounce((id) => {
    const element_to_scroll_to = document.getElementById(id);
    if (element_to_scroll_to) {
      document.getElementById("wp-menu-section").scrollTo({
        left: document.getElementById(id).offsetLeft - 50,
        behavior: "smooth",
      });
    }
  }, 300);

  useEffect(() => {
    const fetch = async () => {
      const data = await getDiaries(doctor.id);
      setDataShowcase(data?.data || []);
    };
    fetch();
  }, []);

  const scrollToReview = () => {
    scroller.scrollTo("danh-gia", {
      duration: 1500,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };
  const closeModalRating = () => {
    setOpenModalRating(false);
  };

  const clinicLogo = doctor?.doctor_clinic[0]?.clinic.image.find(
    (item) => item.image_type == "AVATAR"
  );

  const avatar = doctor?.image.find((item) => item.image_type == "AVATAR");

  const certificates = doctor?.image.filter(
    (item) => item.image_type == "DOCTOR_CERTIFICATE"
  );

  const textSpecialize = doctor?.doctor_service
    .map((item) => {
      return item?.category_service?.name;
    })
    .join(", ");

  return (
    <div className="wpPageDetailDoctor">
      <div className="wpDoctorDetail">
        <div className="nav">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link href="/">Trang Chủ</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link href={clinicName ? `/phong-kham/${clinicSlug}` : "/bac-si"}>
                {clinicName ? clinicName : "Bác sĩ"}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link href="">{`${doctor.name}`}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="doctorDetail">
          <Row gutter={[16, 16]} className="overviewSection">
            <Col xs={24} lg={13} xl={15} className="wpCover">
              <ImageCommon data={avatar} style="avatar"></ImageCommon>
              <div className="info">
                <h1 className="name">{doctor.name} </h1>
                <span className="rating">
                  <span style={{ marginRight: "3px", marginBottom: "0px" }}>
                    {doctor?.rating_overview?.overall_average
                      ? parseFloat(
                          doctor?.rating_overview.overall_average
                        ).toFixed(1)
                      : 0}{" "}
                  </span>
                  <StarRatings
                    numberOfStars={1}
                    rating={doctor?.average_rating}
                    starDimension="20px"
                    starSpacing="4px"
                    starRatedColor="#ffe140"
                    starEmptyColor="#ffe23f"
                  />
                  <Divider
                    type="vertical"
                    style={{
                      width: "2px",
                      height: "15px",
                      background: "var(--Color-Bg-Orange, #c4c4c4)",
                    }}
                  />
                  {doctor?.rating_overview?.number_of_ratings} đánh giá
                </span>
                <span className="position">
                  <strong>Chức danh:</strong> {doctor?.position}
                </span>
                <span className="specialize">
                  <strong>Chuyên môn:</strong> {textSpecialize}
                </span>
                <span className="experience">
                  <strong>Kinh nghiệm:</strong> {doctor?.experience_time}
                </span>
                <span className="workPlace">
                  <strong className="workPlaceTitle">Nơi công tác:</strong>

                  <ImageCommon data={clinicLogo} style="clinicLogo" />
                  <div className="wp-clinic-name">
                    {doctor.doctor_clinic.map((item) => {
                      return (
                        <Link
                          href={
                            item.clinic.slug
                              ? `/phong-kham/${item.clinic.slug}`
                              : "/bac-si"
                          }
                        >
                          {item.clinic.name + ", "}
                        </Link>
                      );
                    })}
                  </div>
                </span>
                <Button
                  className={`btnOrder`}
                  onClick={() => {
                    setOpenModalChat(true);
                  }}
                  icon={
                    <MessageOutlined
                      style={{ fontSize: "19px" }}
                      twoToneColor="#eb2f96"
                    />
                  }
                >
                  Liên hệ đặt lịch
                </Button>
              </div>
            </Col>
            <Col xs={24} lg={11} xl={9} className="wpPerformence">
              <div className="wpContent">
                <div className="rating">
                  <span>
                    {doctor?.rating_overview?.overall_average
                      ? parseFloat(
                          doctor?.rating_overview.overall_average
                        ).toFixed(1)
                      : 0}
                  </span>
                  <StarRatings
                    rating={doctor?.rating_overview?.overall_average}
                    starDimension="21px"
                    starSpacing="4px"
                    starRatedColor="#ffe140"
                  />
                </div>
                <div className="dash"></div>
                <div className="analysis">
                  {doctor?.success_case ? (
                    <div className="text">
                      {doctor?.success_case}+ case thành công
                    </div>
                  ) : null}
                  <div className="text">
                    {doctor?.total_contact} khách hàng đặt lịch khám qua
                    NhaKhoaHub
                  </div>
                </div>
              </div>
              <div className="wpButton">
                <Button
                  className="eyeRating"
                  icon={<EyeOutlined />}
                  onClick={scrollToReview}
                >
                  Xem đánh giá
                </Button>
                <Button
                  className="editRating"
                  icon={<EditOutlined />}
                  onClick={() => setOpenModalRating(true)}
                >
                  Viết đánh giá
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {/* Menu */}
      <div className={`wpMenu wp-menu-section`} id="wp-menu-section">
        {dataMenuSection.map((item, index) => {
          return (
            <LinkScroll
              activeClass="active"
              className="wp-item-menu"
              to={item.id}
              spy={true}
              smooth={true}
              duration={500}
              offset={-56}
              ignoreCancelEvents={true}
              onSetActive={() => {
                debounceScroll(item.id);
              }}
            >
              <div className="item-menu" id={item.id}>
                {item.name}
              </div>
            </LinkScroll>
          );
        })}
      </div>
      <div className="wpSection">
        <div className="wpContent">
          <Element name="gioi-thieu" className="element">
            <h2 className="titleSection">Giới Thiệu</h2>
            <div className="dash"></div>
            {doctor?.introduce ? (
              <div
                className="textInnerHTML"
                dangerouslySetInnerHTML={{ __html: doctor?.introduce }}
              />
            ) : (
              <div
                style={{
                  color: "#2a3467",
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "16px",
                  margin: "12px 0px",
                }}
              >
                Chưa có thông tin{" "}
              </div>
            )}
          </Element>
          <Element name="kinh-nghiem" className="element">
            <h2 className="titleSection">Kinh Nghiệm</h2>
            <div className="dash"></div>
            {doctor?.work_experience ? (
              <div
                className="textInnerHTML"
                dangerouslySetInnerHTML={{ __html: doctor?.work_experience }}
              />
            ) : (
              <div
                style={{
                  color: "#2a3467",
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "16px",
                  margin: "12px 0px",
                }}
              >
                Chưa có thông tin{" "}
              </div>
            )}
          </Element>
          <Element name="bang-cap" className="element">
            <h2 className="titleSection">Bằng cấp, chứng chỉ</h2>
            <div className="dash"></div>
            {certificates.length > 0 ? (
              <Swiper
                breakpoints={{
                  0: {
                    slidesPerView: 1.2,
                  },
                  768: {
                    slidesPerView: 2.2,
                  },
                  1024: {
                    slidesPerView: 2.5,
                  },
                }}
                spaceBetween={10}
                // modules={[Pagination]}
                className="doctor-certificate-swiper"
              >
                <SwiperButtonNext />
                {certificates.map((item) => {
                  return (
                    <SwiperSlide className="col-certificate">
                      <div className="wp-certificate-image">
                        <ImageAntd
                          src={
                            item.key
                              ? `${PREFIX_IMAGE_URL}${item.key}`
                              : "error"
                          }
                          fallback={FALLBACK}
                          className="certificate-image"
                          preview={{
                            mask: false,
                          }}
                        ></ImageAntd>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            ) : (
              <div
                style={{
                  color: "#2a3467",
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "16px",
                  margin: "12px 0px",
                }}
              >
                Chưa có thông tin{" "}
              </div>
            )}
          </Element>
          <Element name="cong-tac" className="element">
            <h2 className="titleSection">Nơi công tác</h2>
            <div className="dash"></div>
            <Swiper
              modules={[Pagination, Scrollbar, Autoplay]}
              loop={true}
              autoplay={{ delay: 3000 }}
              pagination={{ clickable: true }}
            >
              {doctor.doctor_clinic.map((item) => {
                return (
                  <SwiperSlide className="wp-item">
                    <WorkPlace detailClinic={item.clinic} />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </Element>

          <Element name="showcase" className="element">
            <h2 className="titleSection">Showcase</h2>
            <div className="dash"></div>
            {dataShowcase?.length > 0 ? (
              <div className="showcase">
                <DiaryDoctor diaryData={dataShowcase} />
              </div>
            ) : (
              <div
                style={{
                  color: "#2a3467",
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "16px",
                  margin: "12px 0px",
                }}
              >
                Chưa có thông tin
              </div>
            )}
          </Element>

          <Element name="hoat-dong" className="element">
            <h2 className="titleSection">Hoạt động</h2>
            <div className="dash"></div>
            <Post
              detailClinic={doctor?.doctor_clinic[0].clinic}
              posts={doctor?.post}
              doctor={doctor}
              type={props.type}
            />
          </Element>

          <Element
            name="danh-gia"
            className="element"
            style={{ paddingBottom: "15px" }}
          >
            <h2 className="titleSection">Đánh giá</h2>
            <div className="dash"></div>
            <Review
              dataRatings={doctor}
              doctorId={doctor.id}
              openModalRating={openModalRating}
              closeModalRating={closeModalRating}
            />
          </Element>
        </div>
        <Element name="form-lien-he" className="element wpChat formChatBox">
          <div style={{ position: "sticky", paddingBottom: "15px" }}>
            <ChatBox
              detailClinic={doctor?.doctor_clinic[0].clinic}
              doctor={{
                name: doctor?.name,
                avatar: avatar,
                total_contact: doctor?.total_contact,
              }}
            />
          </div>
        </Element>
      </div>
      <Modal
        className="wpModalChatBox"
        open={openModalChat}
        onCancel={() => {
          setOpenModalChat(false);
        }}
        footer={null}
        closable={false}
        width={380}
        style={{ top: 20 }}
        destroyOnClose={true}
        centered
      >
        <div style={{ position: "relative" }}>
          <ChatBox
            detailClinic={doctor?.clinic}
            isModal={true}
            doctor={{ name: doctor?.name, avatar: avatar }}
          />
          <div
            className="closeModal"
            onClick={() => {
              setOpenModalChat(false);
            }}
          >
            <Image src={iconClose} />
          </div>
        </div>
      </Modal>
      <div
        className="floatButton"
        onClick={() => {
          setOpenModalChat(true);
          setAppendChatAlert(false);
        }}
      >
        <Image
          unoptimized
          src={avatar ? `${PREFIX_IMAGE_URL}${avatar.key}` : defaultImage}
          width={52}
          height={52}
          style={{ objectFit: "contain" }}
          alt="Avatar icon"
        />
        <Image
          src={iconArrow}
          className="arrowFloatButton"
          width={14}
          height={14}
          alt="Arrow float button icon"
        />
        {appendChatAlert && (
          <Image
            src={chatAlert}
            className="chatAlert"
            width={18}
            height={18}
            alt="Chat alert icon"
          />
        )}
      </div>
    </div>
  );
}
